import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../SafeIcon';
import { FiCheck, FiAlertCircle } from 'react-icons/fi';

export const SaveBadge = ({ status }) => {
  if (!status) return null;
  
  const config = {
    success: { icon: FiCheck, text: 'Saved!', cls: 'bg-[#c8f542] text-black' },
    error: { icon: FiAlertCircle, text: 'Save Failed', cls: 'bg-red-500 text-white' }
  };
  
  const { icon, text, cls } = config[status];
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: -8 }} 
      animate={{ opacity: 1, y: 0 }} 
      exit={{ opacity: 0, y: -8 }} 
      className={`flex items-center space-x-1.5 px-3 py-1.5 rounded-full text-xs font-black ${cls}`}
    >
      <SafeIcon icon={icon} className="w-3.5 h-3.5" />
      <span>{text}</span>
    </motion.div>
  );
};